import { render, staticRenderFns } from "./FormTemplateSettings.vue?vue&type=template&id=6b6b8c9d"
import script from "./FormTemplateSettings.vue?vue&type=script&lang=ts"
export * from "./FormTemplateSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports